module.exports = __webpack_public_path__ + "static/media/redHeart.8babe513.svg";